import React from 'react'
import { FiLayers } from 'react-icons/fi'
import LangSelector from '../LangSelector'
import { Button, SectionHeader } from '../../ui/UiComponents'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../context/AuthContext'
import { useSelector } from 'react-redux'

const NavBar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loadingAuth } = useAuth();
  const user = useSelector((state) => state.root.user);

  return (
    <nav className="bg-white shadow-sm">
      <div className="container mx-auto px-4 md:py-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Link to="/">
              <SectionHeader
                title={t("pages.home.title")}
                titleClass="md:text-2xl md:block hidden font-bold"
                titleType="h1"
                icon={FiLayers}
                iconSize={10}
                imageSrc="/logo192.png"
                iconColor="text-primary"
                iconBgColor="bg-transparent"
              />
            </Link>
          </div>
          <div className="flex items-center gap-2">
            <div className="relative">
              <LangSelector dropdownPosition="top-full" showTitle={false} />
            </div>
            {user && !loadingAuth && (
              <Button
                variant="primary"
                size="xs"
                onClick={() => navigate("/my-profile")}
                className='whitespace-nowrap'
              >
                {t("pages.profile.title")}
              </Button>
            )}
            {!user && !loadingAuth && (
              <Button
                variant="outlinePrimary"
                size="xs"
                onClick={() => navigate("/auth/signin")}
                className='whitespace-nowrap'
              >
                {t("pages.auth.signin.title")}
              </Button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBar
